var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "92",
      "height": "63"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M36.927 59.458 1.62 24.128V2.562h21.554L58.48 37.89zM24.083 1.177A.8.8 0 0 0 23.51.94H.81a.81.81 0 0 0-.81.81v22.715c0 .216.084.42.237.573l36.117 36.14a.83.83 0 0 0 1.145 0l22.7-22.714a.81.81 0 0 0 0-1.147z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#24BA80",
      "d": "M15.783 16.732a5.1 5.1 0 0 1-3.621 1.497c-1.311 0-2.622-.5-3.62-1.497a5.134 5.134 0 0 1 0-7.247c1.928-1.93 5.312-1.93 7.24 0a5.134 5.134 0 0 1 0 7.247M12.163 6.55c-1.75 0-3.396.682-4.634 1.92a6.51 6.51 0 0 0-1.917 4.638c0 1.753.68 3.4 1.917 4.636a6.5 6.5 0 0 0 4.634 1.918 6.5 6.5 0 0 0 4.634-1.918 6.51 6.51 0 0 0 1.917-4.636 6.5 6.5 0 0 0-1.917-4.637 6.5 6.5 0 0 0-4.634-1.921m15.984 37.008 14.446-14.455a.717.717 0 0 0-1.013-1.014L27.133 42.545a.71.71 0 0 0-.21.507c0 .19.075.37.21.506a.73.73 0 0 0 1.014 0m5.158 5.164L47.75 34.266a.717.717 0 0 0-1.013-1.014L32.292 47.71a.7.7 0 0 0-.21.506c0 .191.074.37.21.507.27.27.743.27 1.013 0"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M75.724 44.358 53.006 21.624V7.897h13.719L89.442 30.63zm15.23-14.232L67.525 6.679a.72.72 0 0 0-.504-.21H52.293a.714.714 0 0 0-.712.715V21.92a.72.72 0 0 0 .208.505L75.22 45.87a.73.73 0 0 0 1.008 0l14.727-14.736a.715.715 0 0 0 0-1.01z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M61.831 16.728a3.06 3.06 0 0 1-2.173.899c-.788 0-1.574-.3-2.174-.9a3.08 3.08 0 0 1 0-4.35c1.158-1.158 3.189-1.159 4.347 0a3.08 3.08 0 0 1 0 4.35m-2.173-6.677a4.47 4.47 0 0 0-3.182 1.318 4.47 4.47 0 0 0-1.316 3.184 4.48 4.48 0 0 0 1.316 3.185 4.47 4.47 0 0 0 3.182 1.316 4.47 4.47 0 0 0 3.182-1.316 4.47 4.47 0 0 0 1.316-3.185 4.47 4.47 0 0 0-1.316-3.184 4.47 4.47 0 0 0-3.182-1.318M73.55 37.833l9.372-9.379a.715.715 0 0 0-.504-1.217.7.7 0 0 0-.504.208l-9.372 9.379a.715.715 0 0 0 0 1.009.73.73 0 0 0 1.008 0"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }